import { Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { sendLoginSignupOtp } from "../../../State/AuthSlice";

import { useNavigate } from "react-router-dom";
import { fetchSellerProfile, signInSeller } from "../../../State/seller/sellerSlice";

type Props ={
  setLocalError: React.Dispatch<React.SetStateAction<string | null>>;
  setSuccessMessage: React.Dispatch<React.SetStateAction<string | null>>;
}
export const SellerLoginForm:React.FC<Props> = ({setLocalError,setSuccessMessage}) => {
  const dispatch = useAppDispatch();
  const { seller, auth } = useAppSelector((store) => store);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      otp: "",
    },
    onSubmit: async (values) => {
      //submit form data

      try {
        await dispatch(signInSeller(values)).unwrap();
        setSuccessMessage("Successfully Login will be re-direct to dashboard")
        setLocalError(null)
        setTimeout(async() => {
           await dispatch(fetchSellerProfile()).unwrap
           navigate("/seller");// Navigate after 1 second
        }, 500);
      } catch (error:any) {
        setSuccessMessage(null)
        setLocalError(error)
      }
      
    },
  });
  const handleSentOtp = async () => {
   try {
    
     setLocalError(null)
    await dispatch(
      sendLoginSignupOtp({
        email: formik.values.email,
        role: "ROLE_SELLER",
        isSignup: false,
      })
    ).unwrap();
    setSuccessMessage("Otp sent successfully")
   } catch (error:any) {
    setLocalError(error)
   }
  };

  return (
    <div className="">
      <h1 className="text-center font-bold text-xl text-primary pb-5 ">
        Login As a Seller
      </h1>
      <form onSubmit={formik.handleSubmit}>
        <div className="space-y-5">
          <TextField
            fullWidth
            name="email"
            label="Email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          {auth.otpSent && (
            <div className="space-y-2">
              <p className="font-medium text-sm opacity-60">
                Enter OTP Sent to Your Email
              </p>
              <TextField
                fullWidth
                name="otp"
                label="Otp"
                value={formik.values.otp}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.otp && Boolean(formik.errors.otp)}
                helperText={formik.touched.otp && formik.errors.otp}
              />
            </div>
          )}
          {!auth.otpSent ? (
            <Button
              type="button"
              onClick={handleSentOtp}
              fullWidth
              variant="contained"
              sx={{ py: "11px" }}
            >
              Sent otp
            </Button>
          ) : (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ py: "11px" }}
            >
              Login
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};
